import { apiService } from './apiService';

// Category API endpoints
export const categoryApi = {
    // Get all categories
    getCategories: async () => {
        try {
            return await apiService.get('/categories');
        } catch (error) {
            throw error;
        }
    },

    // Get category by ID
    getCategoryById: async (categoryId: string) => {
        try {
            return await apiService.get(`/categories/${categoryId}`);
        } catch (error) {
            throw error;
        }
    },

    // Get subcategories by category ID
    getSubCategoriesByCategoryId: async (categoryId: string) => {
        try {
            return await apiService.get(`/categories/${categoryId}/subcategories`);
        } catch (error) {
            throw error;
        }
    },

    // Get category names and descriptions
    getCategoryNamesAndDescriptions: async () => {
        try {
            return await apiService.get('/categories/names-descriptions');
        } catch (error) {
            throw error;
        }
    },

    // Search categories by description
    searchCategoriesByDescription: async (description: string, page = 1, limit = 10) => {
        try {
            return await apiService.get(`/categories/search-by-description?description=${description}&page=${page}&limit=${limit}`);
        } catch (error) {
            throw error;
        }
    },

    // Create a new category (admin only)
    createCategory: async (categoryData: any) => {
        try {
            return await apiService.post('/categories', categoryData);
        } catch (error) {
            throw error;
        }
    },

    // Update category by ID (admin only)
    updateCategory: async (categoryId: string, categoryData: any) => {
        try {
            return await apiService.put(`/categories/${categoryId}`, categoryData);
        } catch (error) {
            throw error;
        }
    },

    // Delete category by ID (admin only)
    deleteCategory: async (categoryId: string) => {
        try {
            return await apiService.delete(`/categories/${categoryId}`);
        } catch (error) {
            throw error;
        }
    },

    // Add subcategory to category (admin only)
    addSubCategory: async (categoryId: string, subCategoryData: any) => {
        try {
            return await apiService.post(`/categories/${categoryId}/subcategories`, subCategoryData);
        } catch (error) {
            throw error;
        }
    },

    // Remove subcategory from category (admin only)
    removeSubCategory: async (categoryId: string, subCategoryName: string) => {
        try {
            return await apiService.delete(`/categories/${categoryId}/subcategories/${subCategoryName}`);
        } catch (error) {
            throw error;
        }
    },

    // Get category statistics (admin only)
    getCategoryStats: async () => {
        try {
            return await apiService.get('/categories/admin/stats');
        } catch (error) {
            throw error;
        }
    },
};